module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"subscription":"Моя подписка","tariff":"Тариф","change":"Изменить","currency":{"RUB":"рублей"},"expire":"Закончится {date}","expired":"Оплата за подписку просрочена","neverExpire":"Не закончится никогда","nextPayment":"Следующий автоматический платеж {date}"}}')
  delete Component.options._Ctor
}
